export const AllowShareCartOnly = 'AllowShareCartOnly';
export const AllowIndividualCartOnly = 'AllowIndividualCartOnly';
export const AllowBoth = 'AllowBoth';
